import { Separator } from "ui/components/separator";
import classNames from "classnames";

export function AnalyticsStatsCardWithSeparator({
  label,
  value,
  change,
  className,
}) {
  return (
    <div className={classNames(`flex flex-1 max-w-64`, className)}>
      <div
        className={classNames(
          "min-w-32 flex flex-col max-w-52 gap-2 flex-1",
          className
        )}
      >
        <p className="text-sm font-medium text-muted-foreground flex justify-between">
          {label}
          {change > 0 && <span>{change}%</span>}
        </p>
        <p className="text-xl md:text-3xl font-semibold">{value}</p>
      </div>
      <Separator orientation="vertical" className="min-h-16 hidden mx-6 lg:block" />
    </div>
  );
}
